import { Navigate, useLocation } from 'react-router-dom';
import { userAppContext } from '../../context/Context';
import { isTrialExpired, mergeTrialAttributes } from '../../utils/trialUtils';
import { useAuthStore } from '../../store/authStore';
import { logTrialEvaluation } from '../../utils/trialDebug';

const UseProtectedRoute = ({ children }) => {
  const { groups, user } = userAppContext();
  const trialAttributes = useAuthStore(state => state.trialAttributes);
  const trialAttributesLoaded = useAuthStore(state => state.trialAttributesLoaded);
  const userType = useAuthStore(state => state.userType);
  const location = useLocation();

  if (groups?.includes('ROLE_TRIAL') && user) {
    const trialUser = mergeTrialAttributes(user, trialAttributes ?? undefined);
    const expired = isTrialExpired(trialUser);

    logTrialEvaluation('useProtectedRoute', {
      user,
      trialAttributes,
      trialType: userType,
      extra: {
        pathname: location.pathname,
        trialAttributesLoaded,
        willRedirectToPlans: expired && location.pathname !== '/plans',
        waitingForTrialAttributes: !trialAttributesLoaded,
      },
    });

    if (!trialAttributesLoaded) {
      return children;
    }

    if (expired && location.pathname !== '/plans') {
      return <Navigate to="/plans" replace />;
    }
  }

  return children;
};

export default UseProtectedRoute;
